import * as React from "react";
import * as Glob from "../Globale";
import { Metodi } from "../ChiamaWeb";

interface IBottoneAPIProps {
    Nome?: string;
    Testo: string;
    Default?: boolean;
    ClasseAttivo?: string;
    ClasseNonAttivo?: string;
    ClasseAttesa?: string;
    Attivo?: boolean;
    URL: string;
    ParamURLLista?: { [Param: string]: string | number | boolean };
    ParamURLClasse?: any;
    ParamCorpo?: any;
    Metodo?: Metodi;
    OnClick?: (sender: BottoneAPI, dati: any) => void;
    OnErrore?: (sender: BottoneAPI, errore: Error) => void;
    OnInvio?: (sender: BottoneAPI) => any;
    InviaFile?: boolean;
    DataDismiss?: string;
    Visibile?: boolean;
    Icona?: string;
    Alt?: string;
    Conferma?: string;
}

interface IBottoneAPIState {
    Attesa: boolean;
}

export class BottoneAPI extends React.PureComponent<IBottoneAPIProps, IBottoneAPIState> {
    private _DataDismiss = "";
    private _Visibile = false;
    public static defaultProps: Partial<IBottoneAPIProps> = {
        ClasseAttivo: "btn btn-brand",
        ClasseNonAttivo: "btn btn-brand disabled",
        ClasseAttesa: "btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner kt-spinner--light kt-spinner--right",
        Attivo: true,
        Metodo: "GET",
        Default: false,
        InviaFile: false,
        Conferma: undefined
    };

    constructor(props: IBottoneAPIProps) {
        super(props);
        this.state = { Attesa: false };
        this.props.DataDismiss != undefined ? (this._DataDismiss = this.props.DataDismiss) : (this._DataDismiss = "");
    }

    private CalcolaURL(): string {
        let URL: string = this.props.URL;
        if (this.props.ParamURLLista != undefined) {
            URL += URL.indexOf("?") > -1 ? "&" : "?";
            for (let P in this.props.ParamURLLista) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(this.props.ParamURLLista[P]) + "&";
            }
        }
        if (this.props.ParamURLClasse != undefined) {
            URL += URL.indexOf("?") > -1 ? "&" : "?";
            for (let P in this.props.ParamURLClasse) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(this.props.ParamURLClasse[P]) + "&";
            }
        }
        if (URL.toLowerCase().indexOf("sessione=") == -1) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?") + "sessione=" + (Glob.GetSessione() && Glob.GetSessione().Sessione);
        }
        return URL;
    }

    private OnClick() {
        let URL = this.CalcolaURL();
        if (this.state.Attesa) {
            Glob.LogInfo(Glob.LogCat.API, "Già in attesa per caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL);
        }
        else {
            let Continua = true;
            if (this.props.Conferma) {
                Continua = confirm(this.props.Conferma);
            }
            if (!Continua) {
                return;
            }

            this.setState({ Attesa: true });
            Glob.LogInfo(Glob.LogCat.API, "Attesa caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL);

            var RI: RequestInit = {};
            if (this.props.InviaFile && this.props.OnInvio != undefined) {
                RI.method = "POST";
                let OnInvio = this.props.OnInvio(this);
                Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - File (" + this.props.Nome + "): " + this.props.URL, OnInvio);
                if (OnInvio == false) {
                    this.setState({ Attesa: false });
                    return;
                } else {
                    RI.body = OnInvio;
                }
            } else {
                RI.headers = {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                };
                if ((this.props.ParamCorpo != undefined || this.props.OnInvio != undefined) && this.props.Metodo == "GET") {
                    RI.method = "POST";
                } else {
                    RI.method = this.props.Metodo;
                }
                if (this.props.ParamCorpo != undefined) {
                    RI.body = JSON.stringify(this.props.ParamCorpo);
                    Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - ParamCorpo (" + this.props.Nome + "): " + this.props.URL, this.props.ParamCorpo);
                } else {
                    if (this.props.OnInvio != undefined) {
                        let OnInvio = this.props.OnInvio(this);
                        Glob.Log(Glob.LogCat.API, false, "OnInvio per BottoneAPI - OnInvio (" + this.props.Nome + "): " + this.props.URL, OnInvio);
                        if (OnInvio == false) {
                            this.setState({ Attesa: false });
                            return;
                        }
                        RI.body = JSON.stringify(OnInvio);
                    }
                }
            }

            fetch(URL, RI)
                .then(response => {
                    if (response.ok) {
                        response
                            .text()
                            .then(text => {
                                let data = JSON.parse(text, Glob.DateReviver);

                                this.setState({ Attesa: false });
                                Glob.Log(Glob.LogCat.API, false, "Risultato caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL, data);
                                if (this.props.OnClick != undefined) {
                                    this.props.OnClick(this, data);
                                }
                            })
                            .catch(e => {
                                this.setState({ Attesa: false });
                                Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL + " (JSON)", e);
                                if (this.props.OnErrore != undefined) {
                                    this.props.OnErrore(this, e);
                                }
                            });
                    } else {
                        this.setState({ Attesa: false });
                        Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL + " (HTTP)", response);
                        if (this.props.OnErrore != undefined) {
                            this.props.OnErrore(this, new Error(response.statusText));
                        }
                    }
                })
                .catch(e => {
                    this.setState({ Attesa: false });
                    Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL + " (Rete)", e);
                    if (this.props.OnErrore != undefined) {
                        this.props.OnErrore(this, e);
                    }
                });
        }
    }

    public render() {
        this._Visibile = this.props.Visibile == undefined ? true : this.props.Visibile;
        let Classe: string = (this.state.Attesa ? this.props.ClasseAttesa : this.props.Attivo ? this.props.ClasseAttivo : this.props.ClasseNonAttivo) as string;
        if (!this._Visibile) {
            Classe = Classe + " hidden";
        }
        return (
            <button
                type={this.props.Default ? "submit" : "button"}
                className={Classe}
                title={this.props.Alt}
                onClick={e => {
                    e.preventDefault();
                    this.OnClick();
                }}
                data-dismiss={this._DataDismiss}
                disabled={this.props.Attivo != undefined ? !this.props.Attivo : false}
            >
                {this.props.Icona != undefined && <i className={this.props.Icona}></i>}
                <span> {this.props.Testo}</span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BottoneAPI.tsx